import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ClientService } from 'src/app/private/services/client.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-counter',
  imports: [SharedModule],
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.scss'
})
export class CounterComponent {
  @Input() clientId!: string;
  form: FormGroup;
  loading = false;

  initialLoading = true;

  isCounterAdded = false;

  constructor(private fb: FormBuilder,
    private cltService: ClientService,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      event_reg: [null],
      event_reg_prefix: [null],
      event_reg_length: [null],
      // application_number: [null],
      // application_number_prefix: [null],
      // application_number_length: [null],
      ticket_id: [null],
      ticket_id_prefix: [null],
      ticket_id_length: [null],
      counter_id: [null],
    });
  }

  ngOnInit() {
    this.getClientCounter();
  }

  getClientCounter() {

    const body = {
        "client_id": this.clientId
    }

    this.cltService.getCounterById(body).subscribe({
      next: (res) => {
        this.initialLoading = false;
        if (res) {
          this.isCounterAdded = true;
          this.form.patchValue({
            event_reg: res.event_reg,
            event_reg_prefix: res.event_reg_prefix,
            event_reg_length: res.event_reg_length,
            // application_number: res.application_number,
            // application_number_prefix: res.application_number_prefix,
            // application_number_length: res.application_number_length,
            ticket_id: res.ticket_id,
            ticket_id_prefix: res.ticket_id_prefix,
            ticket_id_length: res.ticket_id_length,
            counter_id: res.counter_id,
          });
        }
      },
      error: (err) => {
        this.initialLoading = false;
      }
    });
  }
  
  
  


  onSubmit() {
    if(this.isCounterAdded) {
      this.updateCounter();
    } else{
      this.createCounter();
    }
  }

  updateCounter() {
    const body = {
      "event_reg": this.form.value.event_reg,
      "event_reg_prefix": this.form.value.event_reg_prefix,
      "event_reg_length": this.form.value.event_reg_length,
      // "application_number": this.form.value.application_number,
      // "application_number_prefix": this.form.value.application_number_prefix,
      // "application_number_length": this.form.value.application_number_length,
      "ticket_id": this.form.value.ticket_id,
      "ticket_id_prefix": this.form.value.ticket_id_prefix,
      "ticket_id_length": this.form.value.ticket_id_length,
      "counter_id": this.form.value.counter_id,
    }
    this.loading = true;
    this.cltService.updateCounter(body).subscribe({
      next: (res) => {
        console.log(res);
        this.isCounterAdded = true;
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Counter updated successfully'
        });
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      }
    });
  }



  createCounter() {
    const body = {
      "client_id": this.clientId,
      "event_reg": this.form.value.event_reg,
      "event_reg_prefix": this.form.value.event_reg_prefix,
      "event_reg_length": this.form.value.event_reg_length,
      // "application_number": this.form.value.application_number,
      // "application_number_prefix": this.form.value.application_number_prefix,
      // "application_number_length": this.form.value.application_number_length,
      "ticket_id": this.form.value.ticket_id,
      "ticket_id_prefix": this.form.value.ticket_id_prefix,
      "ticket_id_length": this.form.value.ticket_id_length
    }
    this.loading = true;
    this.cltService.createCounter(body).subscribe({
      next: (res : any) => {
        console.log(res);
        this.isCounterAdded = true;
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Counter created successfully'
        });
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      }
    });
  }

}
